import React from "react";
import { seoDefaults } from "../utils/seoDefaults";
import SEO from "../api/seo";

const TermsAndConditions = () => {
  return (
    <>
      <SEO {...seoDefaults.terms} />
      <div className="pt-20 bg-gray-950 text-white p-8">
        <div className="max-w-4xl mx-auto bg-gray-900 rounded-lg shadow-lg p-8 mt-20">
          <h1 className="text-4xl font-bold text-center mb-8 text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-purple-500">
            Terms and Conditions <br />
            <span className="text-sm">Last updated: 07-July-2025</span>
          </h1>

          <div className="space-y-6 text-gray-300">
            <p>
              Welcome to <strong>Game Ztudio</strong>! By using our website and
              purchasing from us, you agree to the following terms and
              conditions.
            </p>

            <h2 className="text-2xl font-semibold text-cyan-400">
              1. Acceptance of Terms
            </h2>
            <p>
              By accessing Game Ztudio, you accept these terms in full. If you
              disagree, please do not use our services.
            </p>

            <h2 className="text-2xl font-semibold text-cyan-400">
              2. Intellectual Property Rights
            </h2>
            <p>
              All content on Game Ztudio is owned by us or our licensors. You
              are granted limited access solely for personal use.
            </p>

            <h2 className="text-2xl font-semibold text-cyan-400">
              3. Product Information
            </h2>
            <p>
              We aim for accuracy, but cannot guarantee all information is
              current or error-free.
            </p>

            <h2 className="text-2xl font-semibold text-cyan-400">
              4. Orders, Payments, and Pricing
            </h2>
            <ul className="list-disc list-inside ml-4">
              <li>All orders are subject to acceptance and availability.</li>
              <li>
                Prices include applicable taxes unless mentioned otherwise.
              </li>
              <li>We reserve the right to cancel any order at any time.</li>
            </ul>

            <h2 className="text-2xl font-semibold text-cyan-400">
              5. Shipping & Delivery
            </h2>
            <p>
              We aim to dispatch orders promptly but delivery times are
              estimates only.
            </p>

             <h2 className="text-2xl font-semibold text-cyan-400">
              6. Refunds
            </h2>
            <p>
              All sales on Game Ztudio are final. We do not offer any refunds
              for products purchased through our website. Please review your
              order carefully before making a payment. Game Ztudio is a brand
              owned and operated by STAR1 HASH (Registered Sole Proprietorship,
              GST No. 33BVBPM9140A1Z2). By completing a purchase, you agree to
              this refund policy.{" "}
            </p>

            <h2 className="text-2xl font-semibold text-cyan-400">
              7. Cancellation
            </h2>
            <p>
              Once an order has been placed on Game Ztudio, it cannot be
              cancelled under any circumstances. Please ensure that you review
              your cart and product details before confirming your purchase.
              Game Ztudio is a brand owned and operated by STAR1 HASH
              (Registered Sole Proprietorship, GST No. 33BVBPM9140A1Z2). By
              placing an order, you agree to this cancellation policy.{" "}
            </p>

            <h2 className="text-2xl font-semibold text-cyan-400">
              8. User Conduct
            </h2>
            <p>
              Users must not engage in any unlawful or harmful activity on the
              site.
            </p>

            <h2 className="text-2xl font-semibold text-cyan-400">
              9. Limitation of Liability
            </h2>
            <p>
              Gameztudio is a brand owned and operated by STAR1 HASH (Registered Sole Proprietorship, GST No. 33BVBPM9140A1Z2).
            </p>

            <h2 className="text-2xl font-semibold text-cyan-400">
              10. Privacy & Data
            </h2>
            <p>
              We respect your privacy. Please review our Privacy Policy for full
              details.
            </p>

            <h2 className="text-2xl font-semibold text-cyan-400">
              11. Governing Law
            </h2>
            <p>
              These terms are governed by the laws of India. Disputes shall be
              subject to the jurisdiction of courts in India.
            </p>

            <p className="mt-8 text-center text-gray-400">
              For any queries, contact us at{" "}
              <strong>info@gameztudio.com</strong>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default TermsAndConditions;
